export enum NotificationType {
    All = 'All',
    Trades = 'Trades',
    Backtest = 'Backtest',
    Other = 'Other',
    Offers = 'Offers'
};
export const NotificationTabs = ['Offers','Trades','Backtest','Other'];

export const NotificaionRead = 'notification_read';